/* eslint-disable react/prop-types */
import { Button, Card, Col, Form, Select, Tag } from "antd";
import { FaCreditCard } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import CardTitle from "components/CardTitle";

interface PaymentMethodsProps {
  paymentMethodsOptions: any[];
  isSetup?: boolean;
}

export const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  paymentMethodsOptions,
  isSetup,
}) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const selectedValues = Form.useWatch("defaultPaymentMethods", form) || [];

  const tagRender = (props: {
    label?: React.ReactNode;
    closable?: boolean;
    onClose?: (e: React.MouseEvent<HTMLElement>) => void;
  }) => {
    const { label, closable, onClose } = props;

    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        color="#3e849e"
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };

  const handleFilterOption = (input: string, option?: { label?: string }) => {
    return (option?.label?.toLowerCase().indexOf(input.toLowerCase()) ?? -1) >= 0;
  };

  const handleDeselectAll = () => {
    form.setFieldsValue({ defaultPaymentMethods: [] });
  };

  return (
    <Card
      title={<CardTitle icon={<FaCreditCard />} title={t("Accepted payment methods")} />}
      className="antd-newrai-card"
    >
      {selectedValues.length > 0 && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <Button type="link" onClick={handleDeselectAll} size="small">
            {t("Deselect all")}
          </Button>
        </div>
      )}
      <Col xs={24} sm={24}>
        <Form.Item
          name="defaultPaymentMethods"
          rules={[{ required: isSetup, message: t("This field is required") }]}
          label={t("Payment methods")}
        >
          <Select
            mode="multiple"
            filterOption={handleFilterOption}
            tagRender={tagRender}
            options={paymentMethodsOptions}
          />
        </Form.Item>
      </Col>
    </Card>
  );
};
